import { HomePageCard } from "@customTypes/pages/home";
import React from "react";
import { FaRegBell } from "@react-icons/all-files/fa/FaRegBell";
import { FaDollarSign } from "@react-icons/all-files/fa/FaDollarSign";
import { FaRegFolder } from "@react-icons/all-files/fa/FaRegFolder";
import { AiOutlineUser } from "@react-icons/all-files/ai/AiOutlineUser";
import { theme } from "nectar-ui";

export const cardsInfo: HomePageCard[] = [
  {
    title: "Suas novidades",
    subtitle: "Acompanhe as atualizações desde o seu último acesso",
    link: "/news",
    icon: (size = 24) => <FaRegBell size={size} color={theme.standard.colors.gray500} />,
  },
  {
    title: "Processos e casos",
    subtitle: "Veja os detalhes e andamentos dos seus processos e casos",
    link: "/lawsuits",
    icon: (size = 24) => <FaRegFolder size={size} color={theme.standard.colors.gray500} />,
  },
  {
    title: "Pagamentos",
    subtitle: "Confira todos os registros das suas faturas",
    link: "/payments",
    icon: (size = 24) => <FaDollarSign size={size} color={theme.standard.colors.gray500} />,
  },
  {
    title: "Seu perfil",
    subtitle: "Encontre suas informações, documentos e outros arquivos",
    link: "/profile",
    icon: (size = 24) => <AiOutlineUser size={size} color={theme.standard.colors.gray500} />,
  },
];

export const pagesInfoMap = new Map(cardsInfo.map((info) => [info.link, info]));

export const hiddenPages = ["/payments", "/news"];
